module.exports = __webpack_public_path__ + "static/media/93ConnectBorder.d8df431e.png";